import { render, staticRenderFns } from "./contrPage.vue?vue&type=template&id=98bac518"
import script from "./contrPage.vue?vue&type=script&lang=js"
export * from "./contrPage.vue?vue&type=script&lang=js"
import style0 from "./contrPage.vue?vue&type=style&index=0&id=98bac518&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports